import { render } from "./MuddemaalCreate.vue?vue&type=template&id=1373d65c&scoped=true"
import script from "./MuddemaalCreate.vue?vue&type=script&lang=js"
export * from "./MuddemaalCreate.vue?vue&type=script&lang=js"

import "./MuddemaalCreate.vue?vue&type=style&index=0&id=1373d65c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1373d65c"]])

export default __exports__